module.exports = __webpack_public_path__ + "static/media/meta-front.3c44cfb6.png";